<template>
    <div class="MonitorType" v-if='contentShow'>
        <div class="allChoose" @click="allChooseBtn">
            <p>监控消息类型</p>
            <div class='allTitleBtn'>
                <div class="allChooseBtn" v-if="allChoose">
                    <i class="iconfont icon-duihao1"></i>
                </div>
                <div class="allChooseBtn" v-if="!allChoose" style="background-color:transparent;border:1px solid #565656;box-sizing:border-box;"></div>
                <span>全选</span>
            </div>
        </div>
        <div class="contentDiv">
            <div class='contentBigDiv' v-for="(ite, ke, ind) in dataList">
                <div class='contentDivTitle'>
                    <p>{{dataList[ke].name}}</p>
                    <p>（必选）</p>
                </div>
                <div v-if='(dataList[ke].list.length > 0 || (Object.keys(dataList[ke].list)).length>0)' class="contentItem" v-for="(item, key, index) in dataList[ke].list" :key="index">
                    <p>{{item.name}}</p>
                    <div class="itemList">
                        <div :class="_item.is_selected==1 ?'tagActive tagDiv' :'tagDiv'" v-for="(_item, _index) in item.list" :key="_index" @click="tagChoose(ke, key, _index)">
                            <div class="chooseBtn" v-if="_item.is_selected==1">
                                <i class="iconfont icon-duihao1"></i>
                            </div>
                            <div class="chooseBtn" v-if="_item.is_selected==0"></div>
                            <span>{{_item.type_name}}</span>
                        </div>
                    </div>
                </div>
                <div v-if='!(dataList[ke].list.length > 0 || (Object.keys(dataList[ke].list)).length>0)' class='noList'>
                    <i class="iconfont icon-jinggao"></i>
                    <p>此消息类型已被过滤，如想设置请先修改消息过滤设置</p>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="footerBtn">
                <div class="perBtn" @click="prevBtn">上一步</div>
                <div class="saveBtn" @click="saveBtn">保存配置</div>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    components: { Toast },
    data() {
        return {
            dataList: {},
            allChoose: false,
            contentShow: false
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            let parameObj = {
                action: this.$route.query.action,
                receiver_id: this.$route.query.receiver_id,
                visitor_id: this.$route.query.visitor_id
            }
            
            this.$store.dispatch('MonitorType/getSubAccountMonitorMsg',parameObj).then(res=>{ 
                if(res.code == 1000) {
                    this.dataList = res.data
                    this.contentShow = true

                    let typeArr = [];
                    Object.keys(this.dataList).map((key, index) => {
                        Object.keys(this.dataList[key].list).map((v, index) => {
                            this.dataList[key].list[v].list.forEach((_item) => {
                                typeArr.push(_item.is_selected)
                            });
                        });
                    })
                    // 判断是否全部点击全选
                    if (typeArr.findIndex((target) => target === 0) == -1) {
                        this.allChoose = true;
                    } else {
                        this.allChoose = false;
                    }
                }else {
                    Toast(res.message)
                }
            })
        },
        allChooseBtn() {
            this.allChoose = !this.allChoose
            if(!this.allChoose) {
                Object.keys(this.dataList).map((key, index) => {
                    Object.keys(this.dataList[key].list).map((v, index) => {
                        this.dataList[key].list[v].list.forEach((_item) => {
                            _item.is_selected = 0
                        });
                    });
                })
            }else {
                Object.keys(this.dataList).map((key, index) => {
                    Object.keys(this.dataList[key].list).map((v, index) => {
                        this.dataList[key].list[v].list.forEach((_item) => {
                            _item.is_selected = 1
                        });
                    });
                })
            }
        },
        tagChoose(ke, key, _index) {
            this.dataList[ke].list.[key].list[_index].is_selected = this.dataList[ke].list.[key].list[_index].is_selected==1 ?0 :1
            let typeArr = [];
            Object.keys(this.dataList).map((key, index) => {
                Object.keys(this.dataList[key].list).map((v, index) => {
                    this.dataList[key].list[v].list.forEach((_item) => {
                        typeArr.push(_item.is_selected)
                    });
                });
            })
            // 判断是否全部点击全选
            if (typeArr.findIndex((target) => target === 0) == -1) {
                this.allChoose = true;
            } else {
                this.allChoose = false;
            }

            this.$forceUpdate()
            
        },
        prevBtn() {
            let query = {...this.$route.query, ...{from:'MonitorType'}}
            this.$router.push({ path:'NewAddRecipientInfo', query})
        },
        saveBtn() {
            let msg_typeArr = [];
            let customer_levelArr = [];


            let xundan_ids = ''
            let shouhou_ids = ''
            let customer_level_ids = ''
            let fahuo_ids = ''

            let xundan_idsArr = []
            let shouhou_idsArr = []
            let customer_level_idsArr = []
            let fahuo_idsArr = []


            Object.keys(this.dataList).map((key,i)=>{
                if(key == 'msg_type') {
                    Object.keys(this.dataList[key].list).map((v,i)=>{
                        this.dataList[key].list[v].list.forEach((_item) => {
                            msg_typeArr.push(_item.is_selected);
                        });
                    })
                }
                if(key == 'customer_level') {
                    Object.keys(this.dataList[key].list).map((v,i)=>{
                        this.dataList[key].list[v].list.forEach((_item) => {
                            customer_levelArr.push(_item.is_selected);
                        });
                    })
                }


                Object.keys(this.dataList[key].list).map((v,i)=>{
                    if(v == 'xundan') {
                        this.dataList[key].list[v].list.forEach((_item) => {
                            if(_item.is_selected == 1) {
                                xundan_idsArr.push(_item.type_id)
                            }
                        });
                    }
                    if(v == 'shouhou') {
                        this.dataList[key].list[v].list.forEach((_item) => {
                            if(_item.is_selected == 1) {
                                shouhou_idsArr.push(_item.type_id)
                            }
                        });
                    }
                    if(v == 'customer_level') {
                        this.dataList[key].list[v].list.forEach((_item) => {
                            if(_item.is_selected == 1) {
                                customer_level_idsArr.push(_item.type_id)
                            }
                        });
                    }
                    if(v == 'fahuo') {
                        this.dataList[key].list[v].list.forEach((_item) => {
                            if(_item.is_selected == 1) {
                                fahuo_idsArr.push(_item.type_id)
                            }
                        });
                    }
                })
            })

            for(let i in xundan_idsArr) {
                if(i < xundan_idsArr.length-1) {
                    xundan_ids += `${xundan_idsArr[i]},`
                }else {
                    xundan_ids += `${xundan_idsArr[i]}`
                }
            }
            for(let i in shouhou_idsArr) {
                if(i < shouhou_idsArr.length-1) {
                    shouhou_ids += `${shouhou_idsArr[i]},`
                }else {
                    shouhou_ids += `${shouhou_idsArr[i]}`
                }
            }
            for(let i in customer_level_idsArr) {
                if(i < customer_level_idsArr.length-1) {
                    customer_level_ids += `${customer_level_idsArr[i]},`
                }else {
                    customer_level_ids += `${customer_level_idsArr[i]}`
                }
            }
            for(let i in fahuo_idsArr) {
                if(i < fahuo_idsArr.length-1) {
                    fahuo_ids += `${fahuo_idsArr[i]},`
                }else {
                    fahuo_ids += `${fahuo_idsArr[i]}`
                }
            }
            if(msg_typeArr.length==0&&customer_levelArr.length==0) {
                let parame = {
                    receiver_id: this.$route.query.receiver_id,
                    receive_name: this.$route.query.receive_name,
                    role_name: this.$route.query.role_name,
                    action: this.$route.query.action,
                    xundan_ids,
                    shouhou_ids,
                    customer_level_ids,
                    fahuo_ids,
                }
                
                this.$store.dispatch('MonitorType/saveSubAccountMonitorMsg',parame).then(res=> {
                    if(res.code == 1000) {
                        Toast('保存设置成功')
                        setTimeout(()=> {
                            this.$router.push('ChildInformation')
                        },1000)
                    }else {
                        Toast(res.message)
                    }
                })
            }else {
                if(msg_typeArr.length==0 && customer_levelArr.length==0) {
                    let parame = {
                        receiver_id: this.$route.query.receiver_id,
                        receive_name: this.$route.query.receive_name,
                        role_name: this.$route.query.role_name,
                        action: this.$route.query.action,
                        xundan_ids,
                        shouhou_ids,
                        customer_level_ids,
                        fahuo_ids,
                    }
                    
                    this.$store.dispatch('MonitorType/saveSubAccountMonitorMsg',parame).then(res=> {
                        if(res.code == 1000) {
                            Toast('保存设置成功')
                            setTimeout(()=> {
                                this.$router.push('ChildInformation')
                            },1000)
                        }else {
                            Toast(res.message)
                        }
                    })
                }else {
                    if (msg_typeArr.findIndex((target) => target === 1) == -1) {
                        Toast("请至少勾选一个消息类型")
                    } else if (customer_levelArr.findIndex((target) => target === 1) == -1) {
                        Toast("请至少勾选一个客户等级类型")
                    }else {
                        let parame = {
                            receiver_id: this.$route.query.receiver_id,
                            receive_name: this.$route.query.receive_name,
                            role_name: this.$route.query.role_name,
                            action: this.$route.query.action,
                            xundan_ids,
                            shouhou_ids,
                            customer_level_ids,
                            fahuo_ids,
                        }
                        
                        this.$store.dispatch('MonitorType/saveSubAccountMonitorMsg',parame).then(res=> {
                            if(res.code == 1000) {
                                Toast('保存设置成功')
                                setTimeout(()=> {
                                    this.$router.push('ChildInformation')
                                },1000)
                            }else {
                                Toast(res.message)
                            }
                        })
                        
                    }
                }
            }
            

            
        }
    }
}
</script>

<style lang="scss" scoped>
    @import './index.scss';
</style>